import styled from 'styled-components';
import { mediaSize } from '../../styles';


export const Wrapper = styled.div`
  display: grid;
  grid-gap: 10px;
  margin-bottom: 20px;

  @media screen and (min-width: ${mediaSize.desktop}) {
    grid-template-columns: 32% 32% 32%;
  }

  @media screen and (max-width: 1200px) {
    grid-template-columns: 49% 49%;
  }

  @media screen and (max-width: ${mediaSize.tablet}) {
    grid-template-columns: 100%;
  }
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: ${props => props.theme.colors.mainDark};
  padding-bottom: 10px;
`;



// WEBPACK FOOTER //
// ./src/components/editable-list/styles.js